export default __webpack_public_path__ + "static/media/3.bd97cc2f.jpg";